import { useTransactionContext } from 'context/hooks/useTransactionContext';
import {
  findFeeQuote,
  IPayableAmount,
  PaymentMethod,
  resolvePayableAmount,
} from 'utils/feeQuote';

/**
 * What we charge for the given payment method (or the last one they chose), taken from the quotes the backend
 * returned at initiation, plus the provider's own fee for display (see providerFee). Our fees are never calculated
 * here.
 */
export const usePayableAmount = (method?: PaymentMethod): IPayableAmount => {
  const { amount, feeQuotes, provider, paymentMethod } =
    useTransactionContext();
  const selectedMethod = method ?? paymentMethod;

  const quote = selectedMethod
    ? findFeeQuote(feeQuotes, selectedMethod, provider)
    : undefined;

  return resolvePayableAmount(amount, quote, selectedMethod, provider);
};
